/**
 * Hanlde App's Object or Variables watch, auto sync local/server database
 */

//watch global variable changes (AppContext, ExAppContext, etc.) and sync with server, local-storage, on in-app-context updated
import { AppContext, ExAppContext } from '../Context';
import { MemberUser_CommitteeTypeMap } from '../assets/keyMap';
import { useContext, useState, useRef, useEffect } from 'react';
import { Fragment } from 'react';
import { useLocation } from 'react-router';
import { Preferences } from '@capacitor/preferences';
import { IonDate, IonDateString } from '../components/IonDate';
import { Device } from '@capacitor/device';

//classes
import CommitteeType from '../exClasses/committeeType';
import EventCategory from '../exClasses/eventCategory';
import MemberType from '../exClasses/memberType';
import MemberFee from '../exClasses/memberFee';
import InvoiceNote from '../exClasses/invoiceNote';
import DocumentCategory from '../exClasses/documentCategory';
import Broadcast from '../classes/broadcast';
import MembershipRegistration from '../exClasses/membershipRegistration';
import Member from '../classes/member';
import MembershipContract from '../exClasses/membershipContract';
import Event from '../exClasses/event';
import EventRegistration from '../exClasses/eventRegistration';
import Document from '../exClasses/document';
import MemberUser from '../classes/memberUser';
import MeetingInvitation from '../exClasses/meetingInvitation';
import Poll from '../exClasses/poll';
import EventItem from '../exClasses/eventItem';

//controllers
import DatabaseInterfaceController from './DatabaseInterfaceController';
import ClassController from './ClassController';
import HelperFunctionsController from './HelperFunctionsController';

//nonstate
const nonstate = {
    alphabeticalValMap: {
        'a': 0,
        'b': 1,
        'c': 2,
        'd': 3,
        'e': 4,
        'f': 5,
        'g': 6,
        'h': 7,
        'i': 8,
        'j': 9,
        'k': 10,
        'l': 11,
        'm': 12,
        'n': 13,
        'o': 14,
        'p': 15,
        'q': 16,
        'r': 17,
        's': 18,
        't': 19,
        'u': 20,
        'v': 21,
        'w': 22,
        'x': 23,
        'y': 24,
        'z': 25
    }
}

const WatchSyncController = () => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    //states
    const [readBroadcastIds, SetReadBroadcastIds] = useState([] as string[]);
    const [clearedBroadcastIds, SetClearedBroadcastIds] = useState([] as string[]);
    //refs
    const userRef = useRef({} as any);
    // const memberRef = useRef({} as Member);
    const broadcastsRef = useRef<Broadcast[] | null>(null);
    // const meetingInvitationsRef = useRef<MeetingInvitation[]>([] as MeetingInvitation[]); ---deprecated of unused
    const location = useLocation();
    // const newbiePromptRef = useRef<boolean>(appContext.newbiePrompt); --deprecated

    //controllers
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);
    const classController_broadcast = new ClassController('Broadcast');
    const helpers = new HelperFunctionsController();

    // const classController_meetingInvitation = new ClassController('MeetingInvitation'); ---deprecated of unused

    //watchers for user updated
    //test
    // useEffect(() => {
    //     console.log('WatchSyncControllerTest: ' + JSON.stringify(appContext.databaseActionModeQueue));
    // }, [appContext.databaseActionModeQueue]);
    // useEffect(() => {
    //     console.log('WatchSyncControllerTest: ' + JSON.stringify(exAppContext.memberTypes));
    // }, [exAppContext.memberTypes]);

    //initialize onstart
    useEffect(() => {
        databaseInterfaceController.Queue('fetchMemberTypes', [
            ['fetchMemberTypes', 'true']
        ]);
    }, []);

    //initialize on userLogin
    useEffect(() => {
        if (Object.keys(appContext.user).length > 0 && JSON.stringify(userRef.current) != JSON.stringify(appContext.user)) {
            console.log('user logged in!');
            //user logged in
            InitializeFetchUserData();
            InitializeGetUserData();

            //user login successfully, add autit trail
            const UpdateLoginAuditTrail = async () => {
                const deviceInfo = await Device.getInfo();

                databaseInterfaceController.Queue('loginSuccess', [
                    ['loginSuccess', 'true'],
                    ['userID', appContext.user.userID],
                    ['deviceInfo', JSON.stringify(deviceInfo)],
                ]);
            };
            UpdateLoginAuditTrail();
            userRef.current = appContext.user;

        } else if (JSON.stringify(userRef.current) != JSON.stringify(appContext.user)) {
            //user logged out
            appContext.SetStorageRequestMode('remove user');
            appContext.SetStorageRequestParams(['user:userID', 'user:password', 'user:pin_number', 'system:viewMode']);

            //user logout successfully, add autit trail
            const UpdateLogoutAuditTrail = async () => {
                const deviceInfo = await Device.getInfo();

                databaseInterfaceController.Queue('logoutSuccess', [
                    ['logoutSuccess', 'true'],
                    ['userID', userRef.current.userID],
                    ['deviceInfo', JSON.stringify(deviceInfo)],
                ]);
                userRef.current = appContext.user;
            };
            UpdateLogoutAuditTrail();
        } else {
            userRef.current = appContext.user;
        }
    }, [appContext.user]);

    //watch for membership update server
    // useEffect(() => {
    //     if(Object.keys(memberRef.current).length > 0 && JSON.stringify(memberRef.current) != JSON.stringify(exAppContext.membership)) {
    //         databaseInterfaceController.Queue('updateMember', [
    //             ['updateMember', 'true'],
    //             ['memberID', exAppContext.membership.memberID],
    //             ['email', exAppContext.membership.email],
    //             ['telephone_no', exAppContext.membership.telephone_no],
    //             ['fax', exAppContext.membership.fax],
    //             ['registered_address', exAppContext.membership.registered_addres]
    //         ]);
    //     }
    //     memberRef.current = exAppContext.membership;
    // }, [exAppContext.membership]); ---moved to ManageMembership

    //watch for newbiePrompt update local storage newbie prompt
    // useEffect(() => {
    //     if(newbiePromptRef.current != appContext.newbiePrompt) {
    //         newbiePromptRef.current = appContext.newbiePrompt;

    //         appContext.SetStorageRequestMode('set system');
    //         appContext.SetStorageRequestParams([
    //             ['system:newbiePrompt', appContext.newbiePrompt ? 'true' : 'false']
    //         ]);
    //     }
    // }, [appContext.newbiePrompt]); ---deprecated

    //watch for read/cleared broadcast get from local storage, update broadcasts
    useEffect(() => {
        if (appContext.broadcasts.length > 0 && broadcastsRef.current == null && JSON.stringify(appContext.broadcasts) != JSON.stringify(broadcastsRef.current)) {
            const broadcasts: Broadcast[] = appContext.broadcasts;
            readBroadcastIds.map((broadcastID: string) => {
                broadcasts.map((broadcast: Broadcast, i: number) => {
                    if (broadcastID == broadcast.broadcastID)
                        broadcasts.splice(i, 1, classController_broadcast.SetPropertiesOfSubject(broadcast, ['read'], ['true']));
                });
            });

            clearedBroadcastIds.map((broadcastID: string) => {
                broadcasts.map((broadcast: Broadcast, i: number) => {
                    if (broadcastID == broadcast.broadcastID)
                        broadcasts.splice(i, 1, classController_broadcast.SetPropertiesOfSubject(broadcast, ['cleared'], ['true']));
                });
            });
            broadcastsRef.current = broadcasts;
            appContext.SetBroadcasts([...broadcastsRef.current]);
        }
    }, [appContext.broadcasts, readBroadcastIds, clearedBroadcastIds]);

    //watch for broadcasts update, update local storage
    useEffect(() => {
        if (broadcastsRef.current != null && JSON.stringify(appContext.broadcasts) != JSON.stringify(broadcastsRef.current)) {
            //update broadcast cleared or read ids
            const readBroadcastIds = [] as string[];
            const clearedBroadcastIds = [] as string[];
            appContext.broadcasts.map((broadcast: Broadcast) => {
                if (broadcast.read)
                    readBroadcastIds.push(broadcast.broadcastID);
                if (broadcast.cleared)
                    clearedBroadcastIds.push(broadcast.broadcastID);
            });
            appContext.SetStorageRequestMode('set broadcast');
            appContext.SetStorageRequestParams([
                ['broadcast:read', readBroadcastIds.join(',')],
                ['broadcast:cleared', clearedBroadcastIds.join(',')]
            ]);

            broadcastsRef.current = appContext.broadcasts.map((broadcast: Broadcast) => classController_broadcast.Clone(broadcast));
        }
    }, [appContext.broadcasts]);

    //watch for databaseActionMode update
    useEffect(() => {
        if (appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();

                // console.log('checkDatabaseResultAction: ' + mode + ':' + JSON.stringify(res));

                if (!JSON.stringify(res).includes('false')) {
                    let resObjs = [] as any[];
                    let resObj = {} as any;
                    if (
                        mode != 'fetchMemberById' &&
                        mode != 'fetchMembershipById' &&
                        mode != 'fetchMembership' &&
                        mode != 'fetchMembershipRegistration'
                    ) {
                        try {
                            resObjs = JSON.parse(res) as any[];
                        } catch {
                            resObjs = res as any[];
                        }
                    } else {
                        try {
                            resObj = JSON.parse(res) as any;
                        } catch {
                            resObj = res as any;
                        }
                    }

                    switch (mode) {
                        //GENERAL
                        case 'fetchCommitteeTypes':
                            const committeeTypes = [] as CommitteeType[];
                            resObjs.map((resObj: any) => {
                                committeeTypes.push(new CommitteeType(
                                    resObj['committee_typeID'],
                                    resObj['label'],
                                    resObj['description'],
                                    resObj['sort_priority'],
                                    resObj['datetime_created'],
                                    resObj['datetime_updated'],
                                    resObj['creatorID'],
                                    resObj['updaterID']
                                ));
                            });
                            //sort committee types
                            const sorted = [] as CommitteeType[];
                            committeeTypes.map((type: CommitteeType) => {
                                let isSorted = false;
                                sorted.map((_type: CommitteeType, i: number) => {
                                    if (!isSorted && type.sort_priority > _type.sort_priority) {
                                        isSorted = true;
                                        sorted.splice(i, 0, type);
                                    }
                                });
                                if (!isSorted)
                                    sorted.push(type);
                            });
                            exAppContext.SetCommitteeTypes([...sorted]);
                            break;
                        case 'fetchEventCategories':
                            const eventCategories = [] as EventCategory[];
                            resObjs.map((resObj: any) => {
                                eventCategories.push(new EventCategory(
                                    resObj['event_categoryID'],
                                    resObj['event_category_name'],
                                    resObj['event_category_desc'],
                                    resObj['event_category_type']
                                ))
                            });
                            exAppContext.SetEventCategories([...SortEventCategories(eventCategories)]);
                            break;
                        case 'fetchMemberTypes':
                            const memberTypes = [] as MemberType[];
                            resObjs.map((resObj: any) => {
                                memberTypes.push(
                                    new MemberType(
                                        resObj['member_typeID'],
                                        resObj['label'],
                                        resObj['description'],
                                        resObj['datetime_created'],
                                        resObj['datetime_updated'],
                                        resObj['creatorID'],
                                        resObj['updaterID']
                                    )
                                );
                            });
                            exAppContext.SetMemberTypes([...memberTypes]);
                            break;
                        case 'fetchMemberFees':
                            const memberFees = [] as MemberFee[];
                            resObjs.map((resObj: any) => {
                                memberFees.push(
                                    new MemberFee(
                                        resObj['member_feeID'],
                                        resObj['member_typeID'],
                                        resObj['type'],
                                        resObj['label'],
                                        resObj['description'],
                                        resObj['amount'],
                                        resObj['invoice_noteIDs'],
                                        resObj['creatorID'],
                                        resObj['updaterID'],
                                        resObj['datetime_created'],
                                        resObj['datetime_updated']
                                    )
                                );
                            })
                            exAppContext.SetMemberFees([...memberFees]);
                            break;
                        case 'fetchInvoiceNotes':
                            const invoiceNotes = [] as InvoiceNote[];
                            resObjs.map((resObj: any) => {
                                invoiceNotes.push(
                                    new InvoiceNote(
                                        resObj['invoice_noteID'],
                                        resObj['title'],
                                        resObj['description'],
                                        resObj['apply_to_sec_half'],
                                        resObj['datetime_created']
                                    )
                                );
                            })
                            exAppContext.SetInvoiceNotes([...invoiceNotes]);
                            break;
                        case 'fetchDocumentCategories':
                            const documentCategories = [] as DocumentCategory[];
                            resObjs.map((resObj: any) => {
                                documentCategories.push(new DocumentCategory(
                                    resObj['document_categoryID'],
                                    resObj['label'],
                                    resObj['is_newsletter'],
                                    resObj['creator_userID'],
                                    resObj['datetime_created'],
                                    resObj['updater_userID'],
                                    resObj['datetime_updated']
                                ))
                            });
                            exAppContext.SetDocumentCategories([...SortDocumentCategories(documentCategories)]);
                            break;
                        case 'fetchAssociatedBroadcasts':
                            const broadcasts = [] as Broadcast[];
                            resObjs.map((resObj: any) => {
                                broadcasts.push(new Broadcast(
                                    resObj['autoID'],
                                    resObj['poster'],
                                    resObj['title'],
                                    resObj['message'],
                                    resObj['start_date'],
                                    resObj['end_date'],
                                    resObj['action'],
                                    resObj['targeted_member_typeIDs'],
                                    resObj['targeted_member_user_types'],
                                    resObj['targeted_committee_typeIDs'],
                                    resObj['publish'],
                                    resObj['datetime_created'],
                                    false,
                                    false
                                ))
                            });
                            appContext.SetBroadcasts([...broadcasts]);
                            break;
                        //MEMBER_USER
                        case 'fetchMembershipRegistration':
                            exAppContext.SetMembershipRegistration(new MembershipRegistration(
                                resObj['membership_registrationID'],
                                resObj['paymentID'],
                                resObj['initiatorID'],
                                resObj['datetime_created']
                            ));
                            break;
                        case 'fetchMembership':
                            exAppContext.SetMembership(new Member(
                                resObj['membership_registrationID'],
                                resObj['memberID'],
                                resObj['member_typeID'],
                                resObj['accounts_allotment'],
                                resObj['status'],
                                resObj['company_name'],
                                resObj['registered_address'],
                                resObj['correspondence_address'],
                                resObj['complex_representing'],
                                resObj['telephone_no'],
                                resObj['email'],
                                resObj['gross_build_up_area'],
                                resObj['nett_lettable_area'],
                                resObj['website'],
                                resObj['e_invoice_pin'],
                                // resObj['date_of_membership'], ---deprecated
                                resObj['company_number'],
                                resObj['half_year_advance_payment_count'],
                                resObj['datetime_updated'],
                            ));
                            break;
                        case 'fetchMembershipUsers':
                            const membershipUsers = [] as MemberUser[];
                            resObjs.map((obj: any) => {
                                membershipUsers.push(new MemberUser(
                                    obj['membership_registrationID'],
                                    obj['userID'],
                                    obj['memberID'],
                                    obj['type'],
                                    obj['committee_typeID'],
                                    obj['email_verified'],
                                    obj['status'],
                                    obj['last_login'],
                                    obj['nric'],
                                    obj['date_of_birth'],
                                    obj['datetime_created'],
                                    obj['datetime_updated'],
                                    obj['email'],
                                    obj['name'],
                                    obj['pin_number'],
                                    obj['profile_image'],
                                    obj['alternate_email'],
                                    obj['alternate_email_2'],
                                    obj['salutation'],
                                    obj['other_salutation'],
                                    obj['office_tel_no'],
                                    obj['handphone_code'],
                                    obj['handphone_no'],
                                    obj['designation'],
                                    obj['nature_of_work'],
                                    obj['years_with_company'],
                                    obj['academic_qualification'],
                                    obj['address']
                                ));
                            });
                            exAppContext.SetMembershipUsers([...membershipUsers]);
                            break;
                        case 'fetchMembershipContracts':
                            const membershipContracts = [] as MembershipContract[];
                            resObjs.map((resObj: any) => {
                                membershipContracts.push(new MembershipContract(
                                    resObj['contractID'],
                                    resObj['paymentID'],
                                    resObj['memberID'],
                                    resObj['min_term'],
                                    resObj['max_term'],
                                    resObj['datetime_created']
                                ));
                            });
                            exAppContext.SetMembershipContracts([...membershipContracts]);
                            break;
                        case 'fetchUserEventRegistrations':
                            const userEventRegistrations: EventRegistration[] = [] as EventRegistration[];
                            resObjs.map((resObj) => {
                                userEventRegistrations.push(new EventRegistration(
                                    resObj['event_registrationID'],
                                    resObj['eventID'],
                                    resObj['paymentID'],
                                    resObj['initiatorID'],
                                    resObj['beneficiaryIDs'],
                                    resObj['doc_base_url'],
                                    resObj['beneficiary_doc_ics'],
                                    resObj['beneficiary_doc_passports'],
                                    resObj['dietary_options'],
                                    resObj['public_beneficiary_ids'],
                                    resObj['public_beneficiary_salutations'],
                                    resObj['public_beneficiary_fullnames'],
                                    resObj['public_beneficiary_emails'],
                                    resObj['public_beneficiary_phones'],
                                    resObj['public_beneficiary_designations'],
                                    resObj['public_beneficiary_doc_ics'],
                                    resObj['public_beneficiary_doc_passports'],
                                    resObj['public_beneficiary_rpm_nos'],
                                    resObj['public_dietary_options'],
                                    resObj['hrd_claim_status'],
                                    resObj['hrd_grant_status'],
                                    resObj['datetime_created'],
                                    resObj['event_regRefIDs']
                                ));
                            })
                            exAppContext.SetUserEventRegistrations([...userEventRegistrations]);
                            break;
                        case 'fetchUserUpcomingEvents':
                            const userUpcomingEvents: Event[] = [] as Event[];
                            resObjs.map((resObj) => {
                                userUpcomingEvents.push(new Event(
                                    resObj['eventID'],
                                    resObj['event_categoryID'],
                                    resObj['event_name'],
                                    resObj['event_name_highlight_texts'],
                                    resObj['event_name_highlight_colors'],
                                    resObj['event_desc'],
                                    resObj['event_poster'],
                                    resObj['event_file'],
                                    resObj['event_venue'],
                                    resObj['registration_start_date'],
                                    resObj['registration_end_date'],
                                    resObj['early_bird_start_date'],
                                    resObj['early_bird_end_date'],
                                    resObj['event_start_date'],
                                    resObj['event_end_date'],
                                    resObj['event_schedules'],
                                    resObj['max_pax'],
                                    resObj['hostID'],
                                    resObj['datetime_created'],
                                    resObj['datetime_updated'],
                                    resObj['inapp_registration'],
                                    resObj['external_registration_link']
                                    // resObj['base_url'],
                                    // resObj['file_names'] ---deprecated to eventItems
                                ));
                            });
                            exAppContext.SetUserUpcomingEvents([...userUpcomingEvents]);
                            break;
                        case 'fetchViewableDocuments':
                            const viewableDocuments = [] as Document[];
                            resObjs.map((resObj: any) => {
                                viewableDocuments.push(new Document(
                                    resObj['documentID'],
                                    resObj['document_cateogryID'],
                                    resObj['label'],
                                    resObj['description'],
                                    resObj['poster_url'],
                                    resObj['file_url'],
                                    resObj['extra_url'],
                                    resObj['viewable_member_typeIDs'],
                                    resObj['viewable_member_user_types'],
                                    resObj['viewable_committee_typeIDs'],
                                    resObj['creator_userID'],
                                    resObj['datetime_created'],
                                    resObj['dateimte_expired'],
                                    resObj['updater_userID'],
                                    resObj['datetime_updated']
                                ));
                            });
                            exAppContext.SetViewableDocuments([...viewableDocuments]);
                            break;
                        // case 'updateMember':
                        //     if(!JSON.stringify(res).includes('_false')) {
                        //         console.log('updateMemberSuccess');
                        //     } else {
                        //         console.log('updateMemberFailed ' + res);
                        //     }
                        //     break; ---moved to ManageMembership
                        //COMMITTEES
                        case 'fetchAllDocuments':
                            const allDocuments = [] as Document[];
                            resObjs.map((resObj: any) => {
                                allDocuments.push(new Document(
                                    resObj['documentID'],
                                    resObj['document_cateogryID'],
                                    resObj['label'],
                                    resObj['description'],
                                    resObj['poster_url'],
                                    resObj['file_url'],
                                    resObj['extra_url'],
                                    resObj['viewable_member_typeIDs'],
                                    resObj['viewable_member_user_types'],
                                    resObj['viewable_committee_typeIDs'],
                                    resObj['creator_userID'],
                                    resObj['datetime_created'],
                                    resObj['datetime_expired'],
                                    resObj['updater_userID'],
                                    resObj['datetime_updated']
                                ))
                            });
                            exAppContext.SetAllDocuments([...allDocuments]);
                            break;
                        case 'fetchAllCommitteeMembers':
                            const allCommitteeMembers = [] as MemberUser[];
                            resObjs.map((resObj: any) => {
                                allCommitteeMembers.push(new MemberUser(
                                    resObj['membership_registrationID'],
                                    resObj['userID'],
                                    resObj['memberID'],
                                    resObj['type'],
                                    resObj['committee_typeID'],
                                    resObj['email_verified'],
                                    resObj['status'],
                                    resObj['last_login'],
                                    resObj['nric'],
                                    resObj['date_of_birth'],
                                    resObj['datetime_created'],
                                    resObj['datetime_updated'],
                                    resObj['email'],
                                    resObj['name'],
                                    resObj['pin_number'],
                                    resObj['profile_image'],
                                    resObj['alternate_email'],
                                    resObj['alternate_email_2'],
                                    resObj['salutation'],
                                    resObj['other_salutation'],
                                    resObj['office_tel_no'],
                                    resObj['handphone_code'],
                                    resObj['handphone_no'],
                                    resObj['designation'],
                                    resObj['nature_of_work'],
                                    resObj['years_with_company'],
                                    resObj['academic_qualification'],
                                    resObj['address']
                                ))
                            });
                            exAppContext.SetAllCommitteeMembers([...allCommitteeMembers]);
                            break;
                        case 'fetchMeetingInvitations':
                            const meetingInvitations = [] as MeetingInvitation[];
                            const meetingEvents = [] as Event[];
                            resObjs.map((resObj: any) => {
                                meetingInvitations.push(new MeetingInvitation(
                                    resObj['eventID'],
                                    resObj['invitation_userID'],
                                    resObj['invitation_status'],
                                    resObj['remarks'],
                                    resObj['datetime_created'],
                                    resObj['datetime_updated']
                                ));
                                meetingEvents.push(new Event(
                                    resObj['eventID'],
                                    resObj['event_categoryID'],
                                    resObj['event_name'],
                                    resObj['event_name_highlight_texts'],
                                    resObj['event_name_highlight_colors'],
                                    resObj['event_desc'],
                                    resObj['event_poster'],
                                    resObj['event_file'],
                                    resObj['event_venue'],
                                    resObj['registration_start_date'],
                                    resObj['registration_end_date'],
                                    resObj['early_bird_start_date'],
                                    resObj['early_bird_end_date'],
                                    resObj['event_start_date'],
                                    resObj['event_end_date'],
                                    resObj['event_schedules'],
                                    resObj['max_pax'],
                                    resObj['hostID'],
                                    resObj['datetime_created'],
                                    resObj['datetime_updated'],
                                    resObj['inapp_registration'],
                                    resObj['external_registration_link'],
                                    resObj['first_gallery_img']
                                ));
                            });
                            exAppContext.SetMeetingInvitations([...meetingInvitations]);
                            MeetingInvitationsToBroadcasts(meetingInvitations, meetingEvents);
                            break;
                        case 'fetchAcceptedUpcomingMeetings':
                            const meetings = [] as Event[];
                            resObjs.map((resObj: any) => {
                                meetings.push(new Event(
                                    resObj['eventID'],
                                    resObj['event_categoryID'],
                                    resObj['event_name'],
                                    resObj['event_name_highlight_texts'],
                                    resObj['event_name_highlight_colors'],
                                    resObj['event_desc'],
                                    resObj['event_poster'],
                                    resObj['event_file'],
                                    resObj['event_venue'],
                                    resObj['registration_start_date'],
                                    resObj['registration_end_date'],
                                    resObj['early_bird_start_date'],
                                    resObj['early_bird_end_date'],
                                    resObj['event_start_date'],
                                    resObj['event_end_date'],
                                    resObj['event_schedules'],
                                    resObj['max_pax'],
                                    resObj['hostID'],
                                    resObj['datetime_created'],
                                    resObj['datetime_updated'],
                                    resObj['inapp_registration'],
                                    resObj['external_registration_link']
                                ));
                            });
                            exAppContext.SetAcceptedUpcomingMeetings([...meetings]);
                            break;
                        // case 'fetchUnvotedUpcomingPolls': --deprecated
                        case 'fetchUnvotedCurrentAndVotedPolls':
                            const polls = [] as Poll[];
                            resObjs.map((resObj: any) => {
                                polls.push(new Poll(
                                    resObj['pollID'],
                                    resObj['label'],
                                    resObj['options'],
                                    resObj['poll_start'],
                                    resObj['poll_end'],
                                    resObj['votes'],
                                    resObj['voterIDs'],
                                    resObj['viewable_committee_typeIDs'],
                                    resObj['hostID'],
                                    resObj['datetime_created']
                                ));
                            });
                            exAppContext.SetUnvotedCurrentAndVotedPolls([...polls]);
                            break;
                        case 'fetchHostedMeetings':
                            // console.log('hostedMeetingsFetched!: ' + JSON.stringify(res));
                            const hostedMeetings = [] as Event[];
                            const hostedMeetingIDsArr = [] as string[];
                            resObjs.map((resObj: any) => {
                                hostedMeetings.push(new Event(
                                    resObj['eventID'],
                                    resObj['event_categoryID'],
                                    resObj['event_name'],
                                    resObj['event_name_highlight_texts'],
                                    resObj['event_name_highlight_colors'],
                                    resObj['event_desc'],
                                    resObj['event_poster'],
                                    resObj['event_file'],
                                    resObj['event_venue'],
                                    resObj['registration_start_date'],
                                    resObj['registration_end_date'],
                                    resObj['early_bird_start_date'],
                                    resObj['early_bird_end_date'],
                                    resObj['event_start_date'],
                                    resObj['event_end_datet'],
                                    resObj['event_schedules'],
                                    resObj['max_pax'],
                                    resObj['hostID'],
                                    resObj['datetime_created'],
                                    resObj['datetime_updated'],
                                    resObj['inapp_registration'],
                                    resObj['external_registration_link']
                                    // resObj['attachment_base_url'],
                                    // resObj['attachment_file_names'] ---deprecated to eventItems
                                ));
                                hostedMeetingIDsArr.push(resObj['eventID']);
                            });
                            exAppContext.SetHostedMeetings([...hostedMeetings]);

                            //fetch hosted meetingAttachments
                            databaseInterfaceController.Queue('fetchHostedMeetingAttachments', [
                                ['fetchHostedMeetingAttachments', 'true'],
                                ['eventIDs', hostedMeetingIDsArr.join(',')]
                            ]);
                            break;
                        case 'fetchHostedMeetingAttachments':
                            const attachments = [] as EventItem[];

                            resObjs.map((resObj: any) => {
                                attachments.push(new EventItem(
                                    resObj['itemID'],
                                    resObj['eventID'],
                                    resObj['base_url'],
                                    resObj['file_names'],
                                    resObj['datetime_expired'],
                                    resObj['type']
                                ));
                            });

                            exAppContext.SetHostedMeetingAttachments([...attachments]);
                            break;
                        case 'fetchHostedMeetingInvitations':
                            const hostedMeetingInvitations = [] as MeetingInvitation[];
                            resObjs.map((resObj: any) => {
                                hostedMeetingInvitations.push(new MeetingInvitation(
                                    resObj['eventID'],
                                    resObj['invitation_userID'],
                                    resObj['invitation_status'],
                                    resObj['remarks'],
                                    resObj['datetime_created'],
                                    resObj['datetime_updated']
                                ));
                            });
                            exAppContext.SetHostedMeetingInvitations([...hostedMeetingInvitations]);
                            break;
                        case 'fetchHostedPolls':
                            const hostedPolls = [] as Poll[];
                            resObjs.map((resObj: any) => {
                                hostedPolls.push(new Poll(
                                    resObj['pollID'],
                                    resObj['label'],
                                    resObj['options'],
                                    resObj['poll_start'],
                                    resObj['poll_end'],
                                    resObj['votes'],
                                    resObj['voterIDs'],
                                    resObj['viewable_committee_typeIDs'],
                                    resObj['hostID'],
                                    resObj['datetime_created']
                                ))
                            });
                            exAppContext.SetHostedPolls([...hostedPolls]);
                            break;
                        case 'fetchOngoingEvents':

                            const events = [] as Event[];
                            resObjs.map((resObj: any) => {
                                events.push(new Event(
                                    resObj['eventID'],
                                    resObj['event_categoryID'],
                                    resObj['event_name'],
                                    resObj['event_name_highlight_texts'],
                                    resObj['event_name_highlight_colors'],
                                    resObj['event_desc'],
                                    resObj['event_poster'],
                                    resObj['event_file'],
                                    resObj['event_venue'],
                                    resObj['registration_start_date'],
                                    resObj['registration_end_date'],
                                    resObj['early_bird_start_date'],
                                    resObj['early_bird_end_date'],
                                    resObj['event_start_date'],
                                    resObj['event_end_date'],
                                    resObj['event_schedules'],
                                    resObj['max_pax'],
                                    resObj['hostID'],
                                    resObj['datetime_created'],
                                    resObj['datetime_updated'],
                                    resObj['inapp_registration'],
                                    resObj['external_registration_link']
                                ));
                            });
                            exAppContext.SetOngoingEvents([...events]);
                            break;
                        //OTHERS
                        case 'updateMemberUser':
                            if (JSON.stringify(res).includes('_false')) {
                                console.log('updateMemberUserErr: ' + JSON.stringify(res));
                            }
                            break;
                        case 'loginSuccess':
                            if (JSON.stringify(res).includes('_false')) {
                                console.log('loginSuccessErr: ' + res);
                            }
                            break;
                        case 'logoutSuccess':
                            if (JSON.stringify(res).includes('_false')) {
                                console.log('logoutSuccessErr: ' + res);
                            }
                            break;
                    }
                } else {
                    console.log(mode + 'Err: ' + res);
                }
            };

            switch (appContext.databaseActionModeQueue[0]) {
                //GENERAL
                case 'fetchCommitteeTypes':
                case 'fetchEventCategories':
                case 'fetchMemberTypes':
                case 'fetchMemberFees':
                case 'fetchInvoiceNotes':
                case 'fetchDocumentCategories':
                case 'fetchAssociatedBroadcasts':
                //MEMBER_USERS
                case 'fetchMembershipRegistration':
                case 'fetchMembership':
                case 'fetchMembershipUsers':
                case 'fetchMembershipContracts':
                case 'fetchUserEventRegistrations':
                // case 'fetchUserEvents': ---deprecated, renamed to fetchUserUpcomingEvents
                case 'fetchUserUpcomingEvents':
                case 'fetchViewableDocuments':
                // case 'updateMember': ---moved to ManageMembership
                //COMMITTEES
                case 'fetchAllDocuments':
                // case 'fetchAllEvents': ---deprecated
                case 'fetchAllCommitteeMembers':
                case 'fetchMeetingInvitations':
                case 'fetchAcceptedUpcomingMeetings':
                // case 'fetchUnvotedUpcomingPolls': ---deprecated
                case 'fetchUnvotedCurrentAndVotedPolls':
                case 'fetchHostedMeetings':
                case 'fetchHostedMeetingInvitations':
                case 'fetchHostedMeetingAttachments':
                case 'fetchHostedPolls':
                case 'fetchOngoingEvents':
                //OTHERS
                case 'updateMemberUser':
                case 'loginSuccess':
                case 'logoutSuccess':
                    ExecuteDatabaseResultAction();
                    break;
            }
        }
    }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

    //watch for storageRequestResultAction
    useEffect(() => {
        if (appContext.storageRequestResultAction != null && appContext.storageRequestMode != '') {
            let storageRequestResults: any;
            switch (appContext.storageRequestMode) {
                case 'get broadcast':
                    storageRequestResults = appContext.storageRequestResultAction() as any;
                    if (storageRequestResults['read'] != undefined && storageRequestResults['read'] != '') {
                        const readIds = storageRequestResults['read'];
                        SetReadBroadcastIds(readIds.split(','));
                    }
                    if (storageRequestResults['cleared'] != undefined && storageRequestResults['cleared'] != '') {
                        const clearedIds = storageRequestResults['cleared'];
                        SetClearedBroadcastIds(clearedIds.split(','));
                    }
                    break;
            }
        }
    }, [appContext.storageRequestResultAction, appContext.storageRequestMode]);

    //exe functions
    const ProhibitionCheck = (list: string[]) => {
        //prohibits if current page is match with list
        let passFailRes = true;
        if (list.length > 0)
            list.map((prohibited: string) => {
                if (location.pathname.toLowerCase().includes(prohibited.toLowerCase()))
                    passFailRes = false;
            });

        return passFailRes;
    }
    const Acceptioncheck = (list: string[]) => {
        //accepts only if current page is match with list
        let passFailRes = true;
        if (list.length > 0) {
            passFailRes = false;
            list.map((prohibited: string) => {
                if (location.pathname.toLowerCase().includes(prohibited.toLowerCase()))
                    passFailRes = true;
            });
        }

        return passFailRes;
    }
    const InitializeFetchUserData = () => {
        //Fetches for both memberUser and committees
        if (Object.keys(appContext.user).length > 0) {
            databaseInterfaceController.Queue('fetchCommitteeTypes', [
                ['fetchCommitteeTypes', 'true'],
            ]);
            databaseInterfaceController.Queue('fetchEventCategories', [
                ['fetchEventCategories', 'true']
            ]);
            // databaseInterfaceController.Queue('fetchMemberTypes', [
            //     ['fetchMemberTypes', 'true']
            // ]); --move to fetch from the start instead of after login
            databaseInterfaceController.Queue('fetchMemberFees', [
                ['fetchMemberFees', 'true']
            ]);
            databaseInterfaceController.Queue('fetchInvoiceNotes', [
                ['fetchInvoiceNotes', 'true']
            ]);
            databaseInterfaceController.Queue('fetchDocumentCategories', [
                ['fetchDocumentCategories', 'true']
            ]);
            databaseInterfaceController.Queue('fetchAssociatedBroadcasts', [
                ['fetchAssociatedBroadcasts', 'true'],
                ['dateNow', IonDateString(new Date())],
                ['userID', appContext.user.userID]
            ]);
        }
        //If Is Member Fetch
        if (appContext.user.memberID.length > 0) {
            //fetch membership info
            databaseInterfaceController.Queue('fetchMembershipRegistration', [
                ['fetchMembershipRegistration', 'true'],
                ['membershipRegistrationID', appContext.user.membership_registrationID]
            ]);
            databaseInterfaceController.Queue('fetchMembership', [
                ['fetchMembership', 'true'],
                ['memberID', appContext.user.memberID]
            ]);
            databaseInterfaceController.Queue('fetchMembershipUsers', [
                ['fetchMembershipUsers', 'true'],
                ['memberID', appContext.user.memberID]
            ]);
            //fetch membership contracts
            databaseInterfaceController.Queue('fetchMembershipContracts', [
                ['fetchMembershipContracts', 'true'],
                ['memberID', appContext.user.memberID]
            ]);
            //fetch memberEventRegistrations
            databaseInterfaceController.Queue('fetchUserEventRegistrations', [
                ['fetchUserEventRegistrations', 'true'],
                ['userID', appContext.user.userID]
            ]);
            //fetch member associated events
            // databaseInterfaceController.Queue('fetchUserEvents', [
            //     ['fetchUserEvents', 'true'],
            //     ['userID', appContext.user.userID]
            // ]); ---deprecated
            //fetch user associated upcomingEvents
            databaseInterfaceController.Queue('fetchUserUpcomingEvents', [
                ['fetchUserUpcomingEvents', 'true'],
                ['userID', appContext.user.userID],
                ['dateNow', IonDateString(new Date())]
            ]);
            //fetch viewable documents
            databaseInterfaceController.Queue('fetchViewableDocuments', [
                ['fetchViewableDocuments', 'true'],
                ['memberID', appContext.user.memberID],
                ['memberUserType', appContext.user.type]
            ]);
        }
        //If Is Committee Fetch
        if (appContext.user.committee_typeID.length > 0) {
            databaseInterfaceController.Queue('fetchAllDocuments', [
                ['fetchAllDocuments', 'true']
            ]);
            // databaseInterfaceController.Queue('fetchAllEvents', [
            //     ['fetchAllEvents', 'true']
            // ]); ---deprecated
            databaseInterfaceController.Queue('fetchAllCommitteeMembers', [
                ['fetchAllCommitteeMembers', 'true']
            ]);
            databaseInterfaceController.Queue('fetchMeetingInvitations', [
                ['fetchMeetingInvitations', 'true'],
                ['userID', appContext.user.userID]
            ]);
            databaseInterfaceController.Queue('fetchAcceptedUpcomingMeetings', [
                ['fetchAcceptedUpcomingMeetings', 'true'],
                ['userID', appContext.user.userID],
                ['dateNow', IonDateString(new Date())]
            ]);
            // databaseInterfaceController.Queue('fetchUnvotedUpcomingPolls', [
            //     ['fetchUnvotedUpcomingPolls', 'true'],
            //     ['committee_typeID', appContext.user.committee_typeID],
            //     ['dateNow', IonDateString(new Date())],
            //     ['userID', appContext.user.userID]
            // ]); ---deprecated to fetchUnvotedCurrentAndVotedPolls
            databaseInterfaceController.Queue('fetchUnvotedCurrentAndVotedPolls', [
                ['fetchUnvotedCurrentAndVotedPolls', 'true'],
                ['committee_typeID', appContext.user.committee_typeID],
                ['dateNow', IonDateString(new Date())],
                ['userID', appContext.user.userID]
            ]);
            databaseInterfaceController.Queue('fetchHostedMeetings', [
                ['fetchHostedMeetings', 'true'],
                ['hostID', appContext.user.userID]
            ]);
            databaseInterfaceController.Queue('fetchHostedMeetingInvitations', [
                ['fetchHostedMeetingInvitations', 'true'],
                ['hostID', appContext.user.userID]
            ]);
            databaseInterfaceController.Queue('fetchHostedPolls', [
                ['fetchHostedPolls', 'true'],
                ['hostID', appContext.user.userID]
            ]);
            databaseInterfaceController.Queue('fetchOngoingEvents', [
                ['fetchOngoingEvents', 'true'],
                ['dateNow', IonDateString(new Date())]
            ]);
        }
    }
    const InitializeGetUserData = () => {
        //get readed or cleared broadcast ids from local phone storage
        appContext.SetStorageRequestMode('get broadcast');
        appContext.SetStorageRequestParams(['broadcast:read', 'broadcast:cleared']);
    }
    const SortEventCategories = (eventCategories: EventCategory[]) => {
        let res = [] as EventCategory[];
        eventCategories.map((eventCategory: EventCategory) => {
            let isSorted = false;
            res.map((_eventCategory: EventCategory, i: number) => {
                if (!isSorted && IsSmallerStringValue(eventCategory.event_category_name, _eventCategory.event_category_name)) {
                    res.splice(i, 0, eventCategory);
                    isSorted = true;
                }
            });

            if (!isSorted)
                res.push(eventCategory);
        });
        return res;
    }
    const SortDocumentCategories = (documentCategories: DocumentCategory[]) => {
        let res = [] as DocumentCategory[];
        documentCategories.map((documentCategory: DocumentCategory) => {
            let isSorted = false;
            res.map((_documentCategory: DocumentCategory, i: number) => {
                if (!isSorted && IsSmallerStringValue(documentCategory.label, _documentCategory.label)) {
                    res.splice(i, 0, documentCategory);
                    isSorted = true;
                }
            });

            if (!isSorted)
                res.push(documentCategory);
        });
        return res;
    }
    const MeetingInvitationsToBroadcasts = (meetingInvitations: MeetingInvitation[], meetingEvents: Event[]) => {
        const broadcasts = exAppContext.broadcasts;
        meetingInvitations.map((invitation: MeetingInvitation, i: number) => {
            const attemptBroadcastID = invitation.eventID + '-' + invitation.invitation_userID;
            let broadcastExist = false;
            //check is broadcast existed
            broadcasts.map((broadcast: Broadcast) => {
                if (broadcast.broadcastID == attemptBroadcastID)
                    broadcastExist = true;
            });

            if (!broadcastExist) {
                broadcasts.push(new Broadcast(
                    attemptBroadcastID,
                    '',
                    'You have one meeting invitation',
                    'You are invited to attend meeting\nTitle: ' + meetingEvents[i].event_name,
                    IonDateString(meetingEvents[i].event_start_datetime),
                    IonDateString(meetingEvents[i].event_end_datetime),
                    '{"action":"() => { exAppContext.SetViewMode(1); history.push(\'/ViewMeetings\'); }"}',
                    '',
                    '',
                    '',
                    '1',
                    IonDateString(new Date()),
                    false,
                    false
                ));
            }
        });
        exAppContext.SetBroadcasts([...broadcasts]);
    }
    //check functions
    const IsSmallerStringValue = (subject: string, compare: string) => {
        let res = false;
        let subjectValue = [] as number[]; let compareValue = [] as number[];

        helpers.AlpabetsOnly(subject).toLowerCase().split('').map((s: string) => {
            subjectValue.push(nonstate.alphabeticalValMap[s as keyof typeof nonstate.alphabeticalValMap]);
        });
        helpers.AlpabetsOnly(compare).toLowerCase().replace(/\s/g, '').split('').map((c: string) => {
            compareValue.push(nonstate.alphabeticalValMap[c as keyof typeof nonstate.alphabeticalValMap]);
        });

        for (let i = 0; i < subjectValue.length; i++) {
            if (!res && subjectValue[i] < compareValue[i])
                res = true;
            else if (subjectValue[i] > compareValue[i])
                break;
        }

        return res;
    }

    return (<Fragment />);
}

export default WatchSyncController;